import { CAMUNDA_URL } from '@/core/config';
import { server } from '../core/server/axios';
import { Pagination } from './CamundaController';

export class MyFile {
  id?: string;
  name?: string;
  type?: string;
  username?: string;
  uploaded?: Date;
}

export class FileController {

  async upload(file: File): Promise<MyFile> {
    const formData = new FormData();
    formData.append('file', file);
    return await server.post(`/sonata/api/file/upload`, formData, {
      headers: {
        'Content-Type': `multipart/form-data;`
      },
      baseURL: CAMUNDA_URL
    });
  }

  async download(id?: string): Promise<any> {
    return await server.get(`/sonata/api/file/download/${id}`, {
      baseURL: CAMUNDA_URL,
      responseType: 'blob'
    });
  }

  async delete(id?: string) {
    return await server.delete(`/sonata/api/file/${id}`, {
      baseURL: CAMUNDA_URL
    });
  }

  async getFilesContains(
    pageNumber: number,
    pageSize: number,
    name: string
  ): Promise<Pagination<MyFile>> {
    return server.get(
      `/sonata/api/file/${pageNumber}/${pageSize}?name=${name}`,
      {
        baseURL: CAMUNDA_URL
      }
    );
  }
}
